import React from "react";
import SupportContent from "./SupportContent";

const Support = () => {
	return (
		<div className="support-page">
			<section className="hero-section bg-[#ECF2FB] flex flex-col items-center justify-center text-center py-24 md:py-32 px-6">
				<h1 className="text-4xl md:text-6xl font-SatoshiBold text-headerblue">
					We're here to help
				</h1>
				<p className="mt-4 max-w-2xl font-SatoshiRegular text-[#475467]">
					Questions about your account, a project, or billing? Find quick
					answers below or reach our support team directly.
				</p>
			</section>
			<SupportContent />
		</div>
	);
};

export default Support;
